module.exports = Promise.all([__parcel__import__("j5EjQ"), __parcel__import__("5UgbU")]).then(() => parcelRequire('g36Vt'));